import { Injectable, Injector } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class InitialAuthService {

  private authConfig: AuthConfig = {
    issuer: '',
    redirectUri: window.location.origin + window.location.pathname,
    clientId: 'iotsens-control-platform',
    responseType: 'code',
    scope: 'openid profile email',
    requireHttps: false };

  constructor(
    private httpClient: HttpClient,
    private oauthService: OAuthService,
    private injector: Injector
  ) {}

  async initAuth(): Promise<any> {

    return new Promise((resolveFn, rejectFn) => {

      this.httpClient.get('/issuer', )
        .toPromise()
        .then((response: any) => {
          this.authConfig.issuer = response.issuer;
          this.oauthService.configure(this.authConfig);
          this.oauthService.setStorage(localStorage);
          this.oauthService.tokenValidationHandler = new JwksValidationHandler();
          this.oauthService.loadDiscoveryDocumentAndTryLogin().then( isLoggedIn => {
            if (isLoggedIn) {
              this.oauthService.setupAutomaticSilentRefresh();
              resolveFn(true);
            } else {
              this.oauthService.initImplicitFlow();
              rejectFn(false);
            }
          });
        }).catch((err) => window.location.reload());
    });
  }
}
